<template>
    <v-dialog :model-value="modelValue" @update:model-value="$emit('update:modelValue', $event)" max-width="480"
        persistent @keydown.esc="chiudi">
        <v-card v-if="contenuto">
            <v-card-title class="d-flex align-center">
                <v-icon color="success" class="mr-2">mdi-swap-horizontal</v-icon>
                <div>
                    <div>Sostituisci articolo</div>
                    <div class="text-caption text-medium-emphasis font-weight-regular">
                        {{ contenuto.nome }} — scadeva il {{ formattaData(contenuto.dataScadenza) }}
                    </div>
                </div>
            </v-card-title>

            <v-card-text>
                <div class="text-caption text-medium-emphasis mb-2">
                    Il vecchio articolo resta visibile nello storico. Inserisci i dati del nuovo (dalla confezione
                    appena acquistata).
                </div>
                <v-form ref="formRef">
                    <v-text-field v-model="form.nome" label="Nome (vuoto = stesso nome)" class="mb-4" />
                    <v-row>
                        <v-col cols="6">
                            <v-text-field v-model="form.nuovaDataAcquisto" type="date" label="Data acquisto" />
                        </v-col>
                        <v-col cols="6">
                            <v-text-field v-model="form.nuovaDataScadenza" type="date"
                                label="Nuova scadenza (facoltativa)" />
                        </v-col>
                    </v-row>
                    <v-text-field v-model.number="form.quantita" type="number" label="Quantità (vuoto = invariata)"
                        class="mb-4" />
                    <v-textarea v-model="form.note" label="Note" rows="2" />
                </v-form>
            </v-card-text>

            <v-card-actions>
                <v-spacer />
                <v-btn variant="text" @click="chiudi">Annulla</v-btn>
                <v-btn color="success" :loading="salvataggio" @click="conferma">Conferma sostituzione</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: "DialogSostituisciContenuto",

    props: {
        modelValue: { type: Boolean, default: false },
        contenuto: { type: Object, default: null },
        dispositivoSicurezzaId: { type: [Number, String], required: true },
    },
    emits: ["update:modelValue", "sostituito"],

    data() {
        return {
            form: this.formVuoto(),
            salvataggio: false,
        };
    },

    watch: {
        modelValue(val) {
            if (val) this.form = this.formVuoto();
        },
    },

    methods: {
        formVuoto() {
            return {
                nome: "",
                nuovaDataAcquisto: new Date().toISOString().substr(0, 10),
                nuovaDataScadenza: "",
                quantita: null,
                note: "",
            };
        },

        formattaData(iso) {
            if (!iso) return "—";
            return new Date(iso).toLocaleDateString("it-IT", { day: "numeric", month: "long", year: "numeric" });
        },

        async conferma() {
            if (!this.$refs.formRef.validate()) return;

            this.salvataggio = true;
            try {
                const dati = {
                    ...this.form,
                    nuovaDataAcquisto: this.form.nuovaDataAcquisto || null,
                    nuovaDataScadenza: this.form.nuovaDataScadenza || null,
                };
                await this.$store.dispatch("contenutiSicurezza/sostituisci", {
                    id: this.contenuto.id,
                    dati,
                    dispositivoSicurezzaId: this.dispositivoSicurezzaId,
                });
                this.$emit("sostituito");
                this.chiudi();
            } catch (error) {
                console.log(error);
            }
            this.salvataggio = false;
        },

        chiudi() {
            this.$emit("update:modelValue", false);
        },
    },
};
</script>
